(function ($) {

    const MOBILE_BREAKPOINT = 767; // uprav na skutečnou hodnotu vašeho @include max-sm breakpointu

    // sem se přidávají všechny varianty "peek" slideru, které mají mít stejnou logiku bullets
    const PEEK_SLIDER_VARIANTS = ['-peek-slider', '-bullets-slider'];

    function getPeekSliderSelector() {
        return PEEK_SLIDER_VARIANTS
            .map((variant) => `.block-slider.${variant} .swiper-container`)
            .join(', ');
    }

    function isMobileViewport() {
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
    }

    function updateBulletsSingle(swiperInstance) {
        const bullets = swiperInstance.pagination.bullets;
        const activeIndex = swiperInstance.activeIndex;

        bullets.forEach((bullet, index) => {
            bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
        });
    }

    function updateBulletsPaired(swiperInstance) {
        const bullets = swiperInstance.pagination.bullets;
        const activeIndex = swiperInstance.activeIndex;
        const lastIndex = bullets.length - 1;
        const lastVisibleIndex = activeIndex + 1;
        const isAtEnd = swiperInstance.isEnd;

        bullets.forEach((bullet, index) => {
            const shouldBeActive = index === lastIndex
                ? isAtEnd // poslední bullet — jen na skutečném konci, ne při pouhém "peeku"
                : index <= lastVisibleIndex; // ostatní — kumulativní chování

            bullet.classList.toggle('swiper-pagination-bullet-active', shouldBeActive);
        });
    }

    function updateBullets(swiperInstance) {
        if (isMobileViewport()) {
            updateBulletsSingle(swiperInstance);
        } else {
            updateBulletsPaired(swiperInstance);
        }
    }

    function attachBulletPairing(container, attemptsLeft = 20) {
        if (container.swiper) {
            const swiperInstance = container.swiper;
            swiperInstance.on('slideChange', () => updateBullets(swiperInstance));
            updateBullets(swiperInstance); // správný stav hned po načtení
            return;
        }
        if (attemptsLeft > 0) {
            setTimeout(() => attachBulletPairing(container, attemptsLeft - 1), 100);
        }
    }

    function initPeekSliders() {
        document.querySelectorAll(getPeekSliderSelector()).forEach((container) => {
            attachBulletPairing(container);
        });
    }

    initPeekSliders();

    $(document).gp_ready(function () {
        initPeekSliders();
    });

    // Přepočítat i při otočení telefonu / zmenšení okna přes hranici breakpointu
    window.addEventListener('resize', () => {
        document.querySelectorAll(getPeekSliderSelector()).forEach((container) => {
            if (container.swiper) {
                updateBullets(container.swiper);
            }
        });
    });
})(jQuery);